module.exports = __webpack_public_path__ + "img/ELK Stack.6f5f7f18.png";